import * as actions from "Actions";
import * as api from "Api";
import _ from "i18n";
import { TTP_PORTAL_URL } from "Config";

export const saveBloc = groups => (dispatch, getState) => {
  const { token, user, navCommunity } = getState().auth;
  let { blocs } = getState().hub;

  let frame = document.getElementById("previewIframe");

  if (frame) {
    frame.style.display = "none";
    frame.setAttribute("src", "");
  }

  return dispatch(
    actions.saveBloc(
      api
        .saveCommunityLayoutSettings({
          token,
          layoutSettings: blocs,
          communityId: navCommunity.id
        })
        .then(resp => {
          dispatch(
            actions.displayFlashMessage(
              "SUCCESS",
              _("Settings changed successfully")
            )
          );
          if (frame) {
            frame.style.display = "block";
            frame.setAttribute("src", TTP_PORTAL_URL);
          }
          if (resp.data && resp.data.data) {
            dispatch(actions.setLayoutSetting(resp.data.data));
          }
        })
        .catch(() => {
          dispatch(
            actions.displayFlashMessage("ERROR", _("Something went wrong"))
          );
        })
    )
  );
};



// WEBPACK FOOTER //
// ./src/actions/thunks/hub.js